var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingAFY, position, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { useCobranza } from "./hook/cobranza.hook";
import { CobranzaView } from "./view/cobranza.view";
var Cobranza = function () {
    var cobranza = useCobranza();
    return (_jsxs(_Fragment, { children: [cobranza.toast.show &&
                showToast(position.topRight, cobranza.toast.type, cobranza.toast.message, function () { return cobranza.closeToast(); }), _jsx(LoadingAFY, { loading: cobranza.loadingCollections, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(CobranzaView, __assign({}, cobranza))] }));
};
export default Cobranza;
